export const authenticated = state => state.authenticated;
